import { capitalizeFirstLetterOfEachWord } from "./formatting";

export const productTypesForBrandsRequest = {
  vehicleUsed: 'vehicles_used',
  vehicleAccidented: 'vehicles_accidented',
  tyre: 'tyres',
  rim: 'rims',
  part: 'parts',
};

export const getProductLinkFromProduct = (product) => {
  const routeByType = getRouteByType(product.subjectType);

  const { refSource, slug } = product;

  //uppercase slug
  if (slug && typeof slug === 'string') {
    return `/${routeByType}/${refSource}-${slug.toUpperCase()}`;
  }
  return `/${routeByType}/${refSource}`;
};

export const getRouteByType = (type) => {
  const correspondance = {
    vehicle: 'vehicules',
    tyre: 'pneus',
    rim: 'jantes',
    part: 'pieces',
  };

  return correspondance[type];
};

export const getFailoverImage = (type, partCode) => {
  switch (type) {
    case 'App\\Models\\Tyre':
    case 'tyre':
    case 'tyres':
    case 'pneus':
      if (partCode == 3801) {
        return 'failover-double-tyres.png';
      }
      return 'failover-tyres.png';
    case 'App\\Models\\Rim':
    case 'jantes':
    case 'rims':
    case 'rim':
      return 'failover-rims.png';
    case 'App\\Models\\Part':
    case 'pieces':
    case 'part':
    case 'parts':
      return 'failover-parts.png';
    default:
      return 'failover.png';
  }
};

export const productAttributeValueDictionnary = {
  energy: {
    GO: 'Diesel',
    FE: 'Superéthanol',
    ES: 'Essence',
    EL: 'Electrique',
    EH: 'Hybride Essence',
  },
  type: {
    used: 'Occasion',
    accidented: 'Accidenté',
  },
  globalType: {
    vehicle: 'Véhicules',
    tyre: 'Pneus',
    rim: 'Jantes',
    part: 'Pièces détachées',
  },
  transmission: {
    M: 'Manuelle',
    A: 'Automatique',
    V: 'À variation continue',
    CVT: 'À variation continue',
  },
  is2Wheels: {
    1: 'Oui',
    0: 'Non',
  },
  withoutLicense: {
    1: 'Oui',
    0: 'Non',
  },
  // procedure: {
  //   RSV: "Vente aux professionnels ou à l'export",
  //   RIV: 'Vente en ligne',
  //   OCC: 'Occasion',
  //   RAV: 'Vente aux particuliers',
  //   PIECES: 'Pour pièces uniquement',
  // },
};

export const productAttributeLabelDictionnary = {
  partCode: 'Code de la pièce',
  partLabel: 'Article',
  manufacturer: 'Fabricant',
  designation: 'Désignation',
  criteria: 'Critères',
  width: 'Largeur',
  height: 'Hauteur',
  diameter: 'Diamètre',
  speedLoadIndex: 'Indice de vitesse et de charge',
  season: 'Saison',
  status: 'Etat',
  disassemblyDate: 'Date de démontage',
  gamme: 'Gamme',
  model: 'Modèle',
  globalModel: 'Modèle',
  globalType: "Type d'article",
  brand: 'Marque',
  familyModel: 'Famille de modèle',
  finish: 'Finition',
  dateFirstCirculation: 'Date de première circulation',
  vehicleColor: 'Couleur du véhicule',
  manufacturerReferences: 'Référence constructeur',
  serialReferences: 'Référence série',
  rimName: 'Nom de la jante',
  referenceReadOnthePart: 'Références lues sur la pièce',
  oeReference: 'Référence OE',
  numberOfHoles: 'Nombre de trous',
  deportET: 'Déport de jante (ET)',
  type: 'Type',
  refSource: 'Source de référence',
  finition: 'Finition',
  typeCG: 'Type de CG',
  energy: 'Motorisation',
  dateImmat: "Date d'immatriculation",
  colorReference: 'Référence de couleur',
  comments: 'Commentaires',
  mileage: 'Kilométrage (non garanti)',
  damage: 'Dommages',
  price: 'Prix',
  availability: 'Disponibilité',
  manufacturerType: 'Type de fabricant',
  referencesSerialNumber: 'Autres références',
  manufacturerReference: 'Référence constructeur',
  transmission: 'Transmission',
  gears: 'Vitesses',
  gearboxType: 'Type de boîte de vitesses',
  engineType: 'Type de moteur',
  equipmentReference: 'Référence équipementier',
  cylinderCapacity: 'Cylindrée',
  powerHp: 'Puissance (ch)',
  is2Wheels: '2 roues',
  procedure: 'Procédure',
  withoutLicense: 'Voiture sans permis',
};

export const productAttributeSlugDictionnaryForUrl = {
  partCode: 'code-de-la-piece',
  partLabel: 'article',
  manufacturer: 'fabricant',
  designation: 'designation',
  criteria: 'criteres',
  width: 'largeur',
  height: 'hauteur',
  diameter: 'diametre',
  speedLoadIndex: 'indice-de-vitesse-et-de-charge',
  season: 'saison',
  status: 'etat',
  disassemblyDate: 'date-de-demon',
  gamme: 'gamme',
  model: 'modele',
  globalModel: 'modele',
  familyModel: 'famille-de-modele',
  finish: 'finition',
  dateFirstCirculation: 'date-de-premiere-circulation',
  vehicleColor: 'couleur-du-vehicule',
  manufacturerReferences: 'reference-constructeur',
  serialReferences: 'reference-serie',
  rimName: 'nom-de-la-jante',
  referenceReadOnthePart: 'references-lues-sur-la-piece',
  oeReference: 'reference-oe',
  numberOfHoles: 'nombre-de-trous',
  deportET: 'deport-de-jante-et',
  type: 'type',
  refSource: 'source-de-reference',
  finition: 'finition',
  typeCG: 'type-de-cg',
  energy: 'motorisation',
  dateImmat: 'date-d-immatriculation',
  colorReference: 'reference-de-couleur',
  comments: 'commentaires',
  mileage: 'kilometrage',
  damage: 'dommages',
  price: 'prix',
  availability: 'disponibilite',
  manufacturerType: 'type-de-fabricant',
  referencesSerialNumber: 'autres-references',
  manufacturerReference: 'reference-constructeur',
  transmission: 'transmission',
  gears: 'vitesses',
  gearboxType: 'type-de-boite-de-vitesses',
  engineType: 'type-de-moteur',
  equipmentReference: 'reference-equipementier',
  cylinderCapacity: 'cylindree',
  powerHp: 'puissance-ch',
  is2Wheels: '2-roues',
  procedure: 'procedure',
  withoutLicense: 'voiture-sans-permis',
};

export const ENGINE_LABEL = 'MOTEUR';

export const GEARBOX_MECA_LABEL = 'BOITE DE VITESSES';

export const GEARBOX_AUTO_LABEL = 'BOITE DE VITESSES AUTOMATIQUE';

export const WEEK_DAYS_TO_SKIP_FOR_SHIPPING_DELAY = [0, 6];

export const SHIPPING_DELAY_FOR_ENGINE_OR_GEARBOX = 6;

export const SHIPPING_DELAY_FOR_OTHER_PARTS = 2;

export const HOUR_TO_STOP_SHIPPING_DELAY = 10;

export function calculateEstimatedDeliveryDate(
  deliveryDays = 0,
  fromDate = null,
  additionalDays = 0,
) {
  let date = fromDate ? new Date(fromDate) : new Date();

  if (date.getHours() >= HOUR_TO_STOP_SHIPPING_DELAY) {
    date.setDate(date.getDate() + 1);
  }

  while (WEEK_DAYS_TO_SKIP_FOR_SHIPPING_DELAY.includes(date.getDay())) {
    date.setDate(date.getDate() + 1);
  }

  const daysToAdd = deliveryDays + additionalDays;

  for (let i = 0; i < daysToAdd; i++) {
    date.setDate(date.getDate() + 1);
    while (WEEK_DAYS_TO_SKIP_FOR_SHIPPING_DELAY.includes(date.getDay())) {
      date.setDate(date.getDate() + 1);
    }
  }

  return date;
}

export function getSeoDescription(product) {
  let description = product?.seoDescription;

  if (!description) {
    let type = '';

    switch (product?.productable_type) {
      case 'App\\Models\\Tyre':
        type = 'Pneu';
        break;
      case 'App\\Models\\Rim':
        type = 'Jante';
        break;
      case 'App\\Models\\Part':
        type = 'Pièce détachée';
        break;
      case 'App\\Models\\Vehicle':
        type = 'Véhicule';
        break;
    }

    description = `${type} - ${product?.title}${product?.partLabel ? ` - ${product?.partLabel}` : ''}`;
  }

  return description;
}

export function getProductTitle(product, forMeta = false) {
  if (!product?.title) {
    return '';
  }
  return (product?.productable_type == 'App\\Models\\Tyre' ? 
    (product?.partLabel === 'PAIRE DE PNEUS' ?
      (forMeta ?
        'Paire de pneus'
        : 'PAIRE DE PNEUS')
      : 'Pneu'
    ) + ' - '
    : '' )
    + product.title
}